<template>
	<section class="content">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					<div class="card">
						<div class="card-header">
							<h3 class="card-title">
								TOTAL Invoice Unpaid (SEMUA PELANGGAN)
								<small>(Belum Melewati Tanggal Jatuh Tempo)</small>
							</h3>
						</div>
						<div class="card-body ">
							<div class="row">
								<div class="col-md-6">
									<div class="small-box bg-primary">
										<div class="inner">
											<h3>{{ parseInt(jlh_data_pppoe) + parseInt(jlh_data_corpo) }}</h3>
											<small>Jumlah Invoice Unpaid</small>
										</div>
										<div class="icon">
											<i class="fas fa-users"></i>
										</div>
									</div>
								</div>
								<div class="col-md-6">
									<div class="small-box bg-primary">
										<div class="inner">
											<h3>{{ parseInt(ttl_data_pppoe) + parseInt(ttl_data_corpo) | toCurrency }}
											</h3>
											<small>Total Rp Invoice Unpaid</small>
										</div>
										<div class="icon">
											<i class="fas fa-money-bill"></i>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<div class="card">
						<div class="card-header">
							<h3 class="card-title">Daftar Invoice Unpaid <small>(Belum Melewati Tanggal Jatuh
									Tempo)</small></h3>
							<div class="card-tools"></div>
						</div>
						<v-app>
							<v-main>
								<div class="card-body ">
									<ul class="nav nav-tabs custom-tabs" id="custom-content-above-tab" role="tablist">
										<li class="nav-item">
											<a class="nav-link active" id="custom-content-above-home-tab"
												data-toggle="pill" href="#custom-content-above-home" role="tab"
												@click="changeTab(1)" aria-controls="custom-content-above-home"
												aria-selected="true">
												<i class="fa fa-user-alt"></i>
												<span>PPPOE</span>
											</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" id="custom-content-above-profile-tab" data-toggle="pill"
												href="#custom-content-above-profile" role="tab" @click="changeTab(2)"
												aria-controls="custom-content-above-profile" aria-selected="false">
												<i class="fa fa-users"></i>
												<span>CORPORATE</span>
											</a>
										</li>
									</ul>

									<div class="tab-custom-content"></div>

									<div class="tab-content" id="custom-content-above-tabContent">
										<div class="tab-pane fade show active" id="custom-content-above-home"
											role="tabpanel" aria-labelledby="custom-content-above-home-tab">
											<div class="row">
												<div class="col-md-6">
													<div class="small-box bg-primary">
														<div class="inner">
															<h3>{{ parseInt(jlh_data_pppoe) }}</h3>
															<small>Jumlah Invoice Unpaid</small>
														</div>
														<div class="icon">
															<i class="fas fa-users"></i>
														</div>
													</div>
												</div>
												<div class="col-md-6">
													<div class="small-box bg-primary">
														<div class="inner">
															<h3>{{ parseInt(ttl_data_pppoe) | toCurrency }}</h3>
															<small>Total Rp Invoice Unpaid</small>
														</div>
														<div class="icon">
															<i class="fas fa-money-bill"></i>
														</div>
													</div>
												</div>
											</div>
											<v-row class="mb-1">
												<v-col :md="4">
													<div class="form-group mb-2">
														<MonthPicker v-model="filter.periode" label="Filter Periode"
															@input="onFilterChange" class="custom-input" />
													</div>
													<div class="form-group mb-2">
														<KantorCabang v-model="filter.kantor" label="Filter Cabang"
															@input="onFilterChange" class="custom-input" />
													</div>

												</v-col>

												<v-col :md="4" :offset-md="4">
													<TextSearch v-model="filter.search" class="custom-input"
														label="Cari Nama/ID Pelanggan" @input="onFilterChange" />
												</v-col>
											</v-row>
											<v-data-table :headers="headers" :items="datas" :loading="loading"
												:items-per-page="pagination.itemsPerPage" :page.sync="pagination.page"
												:server-items-length="pagination.total"
												:footer-props="{ itemsPerPageOptions: [10, 25, 50, 100] }"
												@update:page="loadUnpaid" @update:items-per-page="changeItemsPerPage"
												show-group-by item-key="id" class="elevation-1">
												<template
													v-slot:group.header="{ group, headers, toggle, isOpen, remove }">
													<td :colspan="headers.length - 1">
														<v-btn @click="toggle" x-small icon :ref="group">
															<v-icon v-if="isOpen">mdi-minus</v-icon>
															<v-icon v-else>mdi-plus</v-icon>
														</v-btn>
														<span class="mx-3"> Nama Pelanggan :
															<span class="font-weight-bold"> {{ group }}</span>
														</span>
													</td>
													<td>
														<v-btn @click="remove" x-small icon class="">
															<v-icon>mdi-close</v-icon>
														</v-btn>
													</td>
												</template>
												<template v-slot:item.no="{ item }">
													{{ item.no | zerofill }}
												</template>
												<template v-slot:item.total_kontrak="{ item }">
													<div class="text-right font-weight-bold">
														{{ parseInt(item.harga_paket) + parseInt(item.ppn_rp) -
															parseInt(item.diskon_rp) | toCurrency }}
													</div>
												</template>
												<template v-slot:item.total_bayar="{ item }">
													<div class="text-right font-weight-bold">
														{{ item.total_bayar | toCurrency }}
													</div>
												</template>
												<template v-slot:item.actions="{ item }">
													<div class="tanpawrap">
														<button class="btn btn-xs btn-danger"
															@click="reloadDataInvoice(item)"
															title="Reload Data Invoice">
															<i class="fas fa-sync"></i>
														</button>
														<button class="btn btn-xs btn-primary" @click="ubahHarga(item)"
															title="Ubah Harga Invoice">
															<i class="fas fa-file-invoice-dollar"></i>
														</button>
														<button class="btn btn-xs btn-warning"
															@click="printInvoice(item)" title="Lihat Invoice">
															<i class="fa fa-file text-white"></i>
														</button>
														<button class="btn btn-xs btn-success"
															@click="printInvoice(item, true)"
															title="Lihat Invoice & PPN">
															<i class="fa fa-file text-white"></i>
														</button>
														<!-- <button class="btn btn-xs btn-info" @click="bukaModal(item)"
															title="Closing Invoice">
															<i class="fa fa-edit"></i>
														</button> -->
													</div>
												</template>
												<template v-slot:no-data>
													<h4>Data Tidak Ditemukan</h4>
												</template>
											</v-data-table>
										</div>
										<div class="tab-pane fade" id="custom-content-above-profile" role="tabpanel"
											aria-labelledby="custom-content-above-profile-tab">
											<div class="row">
												<div class="col-md-6">
													<div class="small-box bg-primary">
														<div class="inner">
															<h3>{{ parseInt(jlh_data_corpo) }}</h3>
															<small>Jumlah Invoice Unpaid</small>
														</div>
														<div class="icon">
															<i class="fas fa-users"></i>
														</div>
													</div>
												</div>
												<div class="col-md-6">
													<div class="small-box bg-primary">
														<div class="inner">
															<h3>{{ parseInt(ttl_data_corpo) | toCurrency }}</h3>
															<small>Total Rp Invoice Unpaid</small>
														</div>
														<div class="icon">
															<i class="fas fa-money-bill"></i>
														</div>
													</div>
												</div>
											</div>
											<v-row class="mb-1">
												<v-col :md="4">
													<!-- <div class="form-group mb-2">
															<MonthPicker v-model="filter.periode" label="Filter Periode"
																@input="onFilterChange" class="custom-input" />
														</div> -->
													<div class="form-group mb-2">
														<KantorCabang v-model="filter.kantor" label="Filter Cabang"
															@input="onFilterChange" class="custom-input" />
													</div>

												</v-col>

												<v-col :md="4" :offset-md="4">
													<TextSearch v-model="filter.search" class="custom-input"
														label="Cari Nama/ID Pelanggan" @input="onFilterChange" />
												</v-col>
											</v-row>

											<v-data-table :headers="headers_corp" :items="datas_corp"
												:items-per-page="pagination_corp.itemsPerPage"
												:page.sync="pagination_corp.page"
												:server-items-length="pagination_corp.total" :loading="loading_corp"
												:footer-props="{ itemsPerPageOptions: [10, 25, 50, 100, -1] }"
												@update:page="fetchDataCorp"
												@update:items-per-page="changeItemsPerPageCorp"
												:search="cari_dt_plg_corp" item-key="id" sort-by="no"
												class="elevation-1" show-group-by>
												<template
													v-slot:group.header="{ group, headers, toggle, isOpen, remove }">
													<td :colspan="headers.length - 1">
														<v-btn @click="toggle" x-small icon :ref="group">
															<v-icon v-if="isOpen">mdi-minus</v-icon>
															<v-icon v-else>mdi-plus</v-icon>
														</v-btn>
														<span class="mx-3"> Nama Pelanggan :
															<span class="font-weight-bold"> {{ group }}</span>
														</span>
													</td>
													<td>
														<v-btn @click="remove" x-small icon class="">
															<v-icon>mdi-close</v-icon>
														</v-btn>
													</td>
												</template>
												<template v-slot:item.no="{ item }">
													{{ item.no | zerofill }}
												</template>
												<template v-slot:item.total_kontrak="{ item }">
													<div class="text-right font-weight-bold">
														{{
															(
																(parseFloat(item.pelanggan_internet.paket.harga) +
																	Math.round(parseFloat(item.pelanggan_internet.paket.harga *
																		item.ppn / 100))) -
																Math.round(((parseFloat(item.pelanggan_internet.paket.harga) +
																	parseFloat(item.pelanggan_internet.paket.harga * item.ppn /
																		100)) *
																	parseFloat(item.pelanggan_internet.diskon / 100)))
															) | toCurrency
														}}
													</div>
												</template>
												<template v-slot:item.total_bayar="{ item }">
													<div class="text-right font-weight-bold">
														{{ item.total_bayar | toCurrency }}
													</div>
												</template>
												<template v-slot:item.actions="{ item }">
													<div class="tanpawrap">
														<button class="btn btn-xs btn-danger"
															@click="reloadDataInvoice(item)"
															title="Reload Data Invoice">
															<i class="fas fa-sync"></i>
														</button>
														<button class="btn btn-xs btn-primary" @click="ubahHarga(item)"
															title="Ubah Harga Invoice">
															<i class="fas fa-file-invoice-dollar"></i>
														</button>
														<button class="btn btn-xs btn-warning"
															@click="printInvoice(item)" title="Lihat Invoice">
															<i class="fa fa-file text-white"></i>
														</button>
														<button class="btn btn-xs btn-success"
															@click="printInvoice(item, true)"
															title="Lihat Invoice & PPN">
															<i class="fa fa-file text-white"></i>
														</button>
														<button class="btn btn-xs btn-info" @click="bukaModal(item)"
															title="Edit Data">
															<i class="fa fa-edit"></i>
														</button>
													</div>
												</template>
												<template v-slot:no-data>
													<h4>Data Tidak Ditemukan</h4>
												</template>
											</v-data-table>
										</div>
									</div>
								</div>
							</v-main>
						</v-app>
						<div class="card-footer"></div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal fade " id="modalUbahHarga" tabindex="-1" role="dialog" aria-labelledby="modalUbahHarga"
			aria-hidden="true" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Edit Harga Invoice</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>

					<form @submit.prevent="updateHargaInvoice()" enctype="multipart/form-data" id="formnya">
						<div class="modal-body">
							<div class="row">
								<div class="col-md-12">
									<div class="card card-outline card-primary">
										<div class="card-header">
											<h3 class="card-title" style="margin:0px">Data Pelanggan</h3>
										</div>
										<div class="card-body">
											<input type="hidden" v-model="form.invoice.id" name="invoice.id">
											<div class="row">
												<div class="col-md-6">
													<div class="form-group">
														<label>Username </label>
														<input type="text" v-model="form.invoice.username"
															name="invoice.username" class="form-control"
															:class="{ 'is-invalid': adaeror['invoice.username'] }"
															:readonly="true">
														<small v-if="adaeror['invoice.username']" class="text-danger">
															{{ adaeror["invoice.username"].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-6">
													<div class="form-group">
														<label>Nama </label>
														<input type="text" v-model="form.invoice.nama"
															name="invoice.nama" class="form-control"
															:class="{ 'is-invalid': adaeror['invoice.nama'] }"
															:readonly="true">
														<small v-if="adaeror['invoice.nama']" class="text-danger">
															{{ adaeror["invoice.nama"].join(', ') }}
														</small>
													</div>
												</div>
											</div>

											<div class="row">
												<div class="col-md-6">
													<div class="form-group">
														<label>Nama Tempat Instalasi </label>
														<input type="text" v-model="form.invoice.nama_tempat"
															name="invoice.nama_tempat" class="form-control"
															:class="{ 'is-invalid': adaeror['invoice.nama_tempat'] }"
															:readonly="true">
														<small v-if="adaeror['invoice.nama_tempat']"
															class="text-danger">
															{{ adaeror["invoice.nama_tempat"].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-6">
													<div class="form-group">
														<label>Paket </label>
														<input type="text" v-model="form.invoice.paket"
															name="invoice.paket" class="form-control"
															:class="{ 'is-invalid': adaeror['invoice.paket'] }"
															:readonly="true">
														<small v-if="adaeror['invoice.paket']" class="text-danger">
															{{ adaeror["invoice.paket"].join(', ') }}
														</small>
													</div>
												</div>
											</div>

											<hr style="border:1px solid;" />
											<h5>Data Billing</h5>
											<div class="row">
												<div class="col-md-4">
													<div class="form-group">
														<label>Harga Paket </label>
														<input type="text" v-model="form.invoice.harga_paket"
															name="invoice.harga_paket" class="form-control"
															:class="{ 'is-invalid': adaeror['invoice.harga_paket'] }"
															:readonly="true">
														<small v-if="adaeror['invoice.harga_paket']"
															class="text-danger">
															{{ adaeror["invoice.harga_paket"].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-2">
													<div class="form-group">
														<label>PPN (Print? <input type="checkbox"
																v-model="form.invoice.print_pajak"
																name="print_pajak">)</label>
														<div class="input-group">
															<input type="text" v-model="form.invoice.ppn"
																name="invoice.ppn" class="form-control"
																:class="{ 'is-invalid': adaeror['invoice.ppn'] }"
																:readonly="true">
															<div class="input-group-append">
																<span class="input-group-text">%</span>
															</div>
														</div>
														<small v-if="adaeror['invoice.ppn']" class="text-danger">
															{{ adaeror["invoice.ppn"].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-2">
													<div class="form-group">
														<label>Diskon </label>
														<div class="input-group">
															<input type="text" v-model="form.invoice.diskon"
																name="invoice.diskon" class="form-control"
																:class="{ 'is-invalid': adaeror['invoice.diskon'] }"
																:readonly="true">
															<div class="input-group-append">
																<span class="input-group-text">%</span>
															</div>
														</div>
														<small v-if="adaeror['invoice.diskon']" class="text-danger">
															{{ adaeror["invoice.diskon"].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-4">
													<div class="form-group">
														<label>PPN KELUARAN (Rp.)</label>
														<input type="number" @keydown="preventArrow($event)"
															v-model="form.invoice.ppn_keluaran" name="ppn_keluaran"
															class="form-control"
															:class="{ 'is-invalid': adaeror['total_potongan'] }"
															:readonly="true">
														<small v-if="adaeror['total_potongan']" class="text-danger">
															{{ adaeror['total_potongan'].join(', ') }}
														</small>
													</div>
												</div>
											</div>

											<div class="row">
												<div class="col-md-4">
													<div class="form-group">
														<label>PPH 23 (Rp.)</label>
														<input type="number" @keydown="preventArrow($event)"
															v-model="form.invoice.pph23" name="pph23"
															class="form-control"
															:class="{ 'is-invalid': adaeror['total_potongan'] }"
															:readonly="true">
														<small v-if="adaeror['total_potongan']" class="text-danger">
															{{ adaeror['total_potongan'].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-4">
													<div class="form-group">
														<label>Zakat (Rp.)</label>
														<input type="number" v-model="form.invoice.zakat" name="zakat"
															class="form-control"
															:class="{ 'is-invalid': adaeror['total_potongan'] }"
															:readonly="true">
														<small v-if="adaeror['total_potongan']" class="text-danger">
															{{ adaeror["total_potongan"].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-4">
													<div class="form-group">
														<label>Cashback (Rp.)</label>
														<input type="number" @keydown="preventArrow($event)"
															v-model="form.invoice.kickback" name="kickback"
															class="form-control"
															:class="{ 'is-invalid': adaeror['kickback'] }"
															:readonly="true">
														<small v-if="adaeror['kickback']" class="text-danger">
															{{ adaeror["kickback"].join(', ') }}
														</small>
													</div>
												</div>
											</div>
											<div class="row">
												<div class="col-md-4">
													<div class="form-group">
														<label>Bulan Pemakaian</label>
														<input type="text" v-model="form.invoice.tagihan"
															name="invoice.tagihan" class="form-control"
															:class="{ 'is-invalid': adaeror['invoice.tagihan'] }"
															:readonly="true">
														<small v-if="adaeror['invoice.tagihan']" class="text-danger">
															{{ adaeror["invoice.tagihan"].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-4">
													<div class="form-group">
														<label>Total Bayar (Rp.)</label>
														<input type="number" @keydown="preventArrow($event)"
															v-model="form.invoice.total_bayar"
															name="invoice.total_bayar" class="form-control"
															:class="{ 'is-invalid': adaeror['invoice.total_bayar'] }">
														<small v-if="adaeror['invoice.total_bayar']"
															class="text-danger">
															{{ adaeror["invoice.total_bayar"].join(', ') }}
														</small>
													</div>
												</div>
											</div>
											<h5><strong>Alasan Perubahan Harga</strong></h5>
											<div class="row">
												<div class="col-md-12">
													<div class="form-group">
														<label>Keterangan</label>
														<textarea v-model="form.invoice.keterangan" style="resize:none;"
															rows="3" name="keterangan" class="form-control"
															:class="{ 'is-invalid': adaeror['keterangan'] }"
															required></textarea>
														<small v-if="adaeror['keterangan']" class="text-danger">
															{{ adaeror["keterangan"].join(', ') }}
														</small>
													</div>
												</div>
											</div>
											<div class="row">
												<div class="col-md-12">
													<div class="form-group">
														<label>Pejabat Approval</label>
														<div class="form-check" v-for="roww in pejabat_list">
															<input type="checkbox" v-model="form.pejabat_approval"
																:id="'ch' + roww.id" :value="roww.id"
																:name="'ch' + roww.id" class="form-check-input">
															<label :for="'ch' + roww.id" class="form-check-label">
																{{ roww.name }}
															</label>
														</div>
														<div v-if="!pejabat_list.length">
															<span class="text-red">Gagal Mengambil Pejabat
																Approval</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
							<button type="submit" class="btn btn-primary"
								v-if="this.form.invoice.total_bayar != this.form.invoice.total">Simpan</button>
							<button type="button" class="btn btn-primary disabled" v-else>Simpan</button>
						</div>
					</form>
				</div>
			</div>
		</div>

		<div class="modal fade " id="modalEdit" tabindex="-1" role="dialog" aria-labelledby="modalEdit"
			aria-hidden="true" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Edit Data Invoice</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>

					<form @submit.prevent="updateInvoice()" enctype="multipart/form-data" id="formnya">
						<div class="modal-body">
							<div class="row">
								<div class="col-md-12">
									<div class="card card-outline card-primary">
										<div class="card-header">
											<h3 class="card-title" style="margin:0px">Data Pelanggan</h3>
										</div>
										<!-- /.card-header -->
										<div class="card-body">
											<input type="hidden" v-model="form.invoice.id" name="invoice.id">
											<div class="row">
												<div class="col-md-6">
													<div class="form-group">
														<label>Username </label>
														<input type="text" v-model="form.invoice.username"
															name="invoice.username" class="form-control"
															:class="{ 'is-invalid': adaeror['invoice.username'] }"
															:readonly="true">
														<small v-if="adaeror['invoice.username']" class="text-danger">
															{{ adaeror["invoice.username"].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-6">
													<div class="form-group">
														<label>Nama </label>
														<input type="text" v-model="form.invoice.nama"
															name="invoice.nama" class="form-control"
															:class="{ 'is-invalid': adaeror['invoice.nama'] }"
															:readonly="true">
														<small v-if="adaeror['invoice.nama']" class="text-danger">
															{{ adaeror["invoice.nama"].join(', ') }}
														</small>
													</div>
												</div>
											</div>

											<div class="row">
												<div class="col-md-6">
													<div class="form-group">
														<label>Nama Tempat Instalasi </label>
														<input type="text" v-model="form.invoice.nama_tempat"
															name="invoice.nama_tempat" class="form-control"
															:class="{ 'is-invalid': adaeror['invoice.nama_tempat'] }"
															:readonly="true">
														<small v-if="adaeror['invoice.nama_tempat']"
															class="text-danger">
															{{ adaeror["invoice.nama_tempat"].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-6">
													<div class="form-group">
														<label>Paket </label>
														<input type="text" v-model="form.invoice.paket"
															name="invoice.paket" class="form-control"
															:class="{ 'is-invalid': adaeror['invoice.paket'] }"
															:readonly="true">
														<small v-if="adaeror['invoice.paket']" class="text-danger">
															{{ adaeror["invoice.paket"].join(', ') }}
														</small>
													</div>
												</div>
											</div>

											<hr style="border:1px solid;" />
											<h5>Data Billing</h5>
											<div class="row">
												<div class="col-md-4">
													<div class="form-group">
														<label>Harga Paket </label>
														<input type="text" v-model="form.invoice.harga_paket"
															name="invoice.harga_paket" class="form-control"
															:class="{ 'is-invalid': adaeror['invoice.harga_paket'] }"
															:readonly="true">
														<small v-if="adaeror['invoice.harga_paket']"
															class="text-danger">
															{{ adaeror["invoice.harga_paket"].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-2">
													<div class="form-group">
														<label>PPN (Print? <input type="checkbox"
																v-model="form.invoice.print_pajak" name="print_pajak">)
														</label>
														<div class="input-group">
															<input type="text" v-model="form.invoice.ppn"
																name="invoice.ppn" class="form-control"
																:class="{ 'is-invalid': adaeror['invoice.ppn'] }"
																:readonly="true">
															<div class="input-group-append">
																<span class="input-group-text">%</span>
															</div>
														</div>
														<small v-if="adaeror['invoice.ppn']" class="text-danger">
															{{ adaeror["invoice.ppn"].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-2">
													<div class="form-group">
														<label>Diskon </label>
														<div class="input-group">
															<input type="text" v-model="form.invoice.diskon"
																name="invoice.diskon" class="form-control"
																:class="{ 'is-invalid': adaeror['invoice.diskon'] }"
																:readonly="true">
															<div class="input-group-append">
																<span class="input-group-text">%</span>
															</div>
														</div>

														<small v-if="adaeror['invoice.diskon']" class="text-danger">
															{{ adaeror["invoice.diskon"].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-4">
													<div class="form-group">
														<label>PPN KELUARAN (Rp.)</label>
														<input type="number" @keydown="preventArrow($event)"
															v-model="form.invoice.ppn_keluaran" name="ppn_keluaran"
															class="form-control"
															:class="{ 'is-invalid': adaeror['total_potongan'] }"
															:readonly="true">
														<small v-if="adaeror['total_potongan']" class="text-danger">
															{{ adaeror['total_potongan'].join(', ') }}
														</small>
													</div>
												</div>
											</div>

											<div class="row" v-show="tipe_pelanggan_edit == '2'">
												<div class="col-md-4">
													<div class="form-group">
														<label>Tanggal Terbit Invoice</label>
														<v-menu v-model="menu" :close-on-content-click="false"
															:nudge-right="40" transition="scale-transition" offset-y
															min-width="auto">
															<template v-slot:activator="{ on, attrs }">
																<v-text-field style="margin-top:0px;padding-top:0px"
																	v-model="form.invoice.tanggal" label=""
																	prepend-icon="mdi-calendar" readonly v-bind="attrs"
																	v-on="on"></v-text-field>
															</template>
															<v-date-picker v-model="form.invoice.tanggal"
																@input="menu = false"></v-date-picker>
														</v-menu>
														<small v-if="adaeror['invoice.tanggal']" class="text-danger">
															{{ adaeror["invoice.tanggal"].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-4">
													<div class="form-group">
														<label>Tanggal Batas Bayar</label>
														<v-menu v-model="menu2" :close-on-content-click="false"
															:nudge-right="40" transition="scale-transition" offset-y
															min-width="auto">
															<template v-slot:activator="{ on, attrs }">
																<v-text-field style="margin-top:0px;padding-top:0px"
																	v-model="form.invoice.tanggal_batas_bayar" label=""
																	prepend-icon="mdi-calendar" readonly v-bind="attrs"
																	v-on="on"></v-text-field>
															</template>
															<v-date-picker v-model="form.invoice.tanggal_batas_bayar"
																@input="menu2 = false"></v-date-picker>
														</v-menu>
														<small v-if="adaeror['invoice.tanggal_batas_bayar']"
															class="text-danger">
															{{ adaeror["invoice.tanggal_batas_bayar"].join(', ') }}
														</small>
													</div>
												</div>
											</div>
											<div class="row">
												<div class="col-md-4">
													<div class="form-group">
														<label>PPH 23 (Rp.)</label>
														<input type="number" @keydown="preventArrow($event)"
															v-model="form.invoice.pph23" name="pph23"
															class="form-control"
															:class="{ 'is-invalid': adaeror['total_potongan'] }"
															:readonly="true">
														<small v-if="adaeror['total_potongan']" class="text-danger">
															{{ adaeror['total_potongan'].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-4">
													<div class="form-group">
														<label>Zakat (Rp.)</label>
														<input type="number" v-model="form.invoice.zakat" name="zakat"
															class="form-control"
															:class="{ 'is-invalid': adaeror['total_potongan'] }"
															:readonly="true">
														<small v-if="adaeror['total_potongan']" class="text-danger">
															{{ adaeror["total_potongan"].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-4">
													<div class="form-group">
														<label>Cashback</label>
														<input type="number" @keydown="preventArrow($event)"
															v-model="form.invoice.kickback" name="kickback"
															class="form-control"
															:class="{ 'is-invalid': adaeror['kickback'] }"
															:readonly="true">
														<small v-if="adaeror['kickback']" class="text-danger">
															{{ adaeror["kickback"].join(', ') }}
														</small>
													</div>
												</div>
											</div>
											<div class="row">
												<div class="col-md-4">
													<div class="form-group">
														<label>Bulan Pemakaian</label>
														<input type="text" v-model="form.invoice.tagihan"
															name="invoice.tagihan" class="form-control"
															:class="{ 'is-invalid': adaeror['invoice.tagihan'] }"
															:readonly="true">
														<small v-if="adaeror['invoice.tagihan']" class="text-danger">
															{{ adaeror["invoice.tagihan"].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-4">
													<div class="form-group">
														<label>Total Bayar</label>
														<input type="number" @keydown="preventArrow($event)"
															v-model="form.invoice.total_bayar"
															name="invoice.total_bayar" class="form-control"
															:class="{ 'is-invalid': adaeror['invoice.total_bayar'] }"
															:readonly="true">
														<small v-if="adaeror['invoice.total_bayar']"
															class="text-danger">
															{{ adaeror["invoice.total_bayar"].join(', ') }}
														</small>
													</div>
												</div>
												<div class="col-md-4">
													<div class="form-group">
														<label>Status </label>
														<select class="form-control is-warning"
															v-model="form.invoice.status_bayar"
															name="invoice.status_bayar">
															<option :key="2" :value="0" selected>Unpaid</option>
															<option :key="1" :value="1">Paid</option>
														</select>
														<small v-if="adaeror['invoice.status_bayar']"
															class="text-danger">
															{{ adaeror["invoice.status_bayar"].join(', ') }}
														</small>
													</div>
												</div>
											</div>
											<!-- Input file hanya tampil kalau Paid -->
											<div class="row" v-if="form.invoice.status_bayar == 1">
												<div class="col-md-12">
													<div class="form-group">
														<label>Upload Bukti Pembayaran</label>
														<div class="custom-file">
															<input type="file" id="file" name="file"
																class="custom-file-input" @change="onUploadFile"
																:class="{ 'is-invalid': adaeror['file'] }"
																accept="image/*,.pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
															<label class="custom-file-label" for="file">
																{{ filename ? filename : 'Choose File' }}
															</label>
															<small v-if="adaeror['file']" class="text-danger">
																{{ adaeror["file"].join(', ') }}
															</small>
														</div>
													</div>

												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
							<button type="submit" class="btn btn-primary">Simpan</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import MonthPicker from '../../base-components/MonthPicker.vue'
import KantorCabang from '../../base-components/KantorCabang.vue'
import TextSearch from '../../base-components/TextSearch.vue';
export default {
	components: {
		MonthPicker,
		KantorCabang,
		TextSearch
	},
	data() {
		return {
			activeTab: 1,
			filter: {
				periode: new Date().toISOString().slice(0, 7),
				kantor: null,
				search: null,
			},
			pejabat_list: [],
			filter_corp: "0",
			filter_pppoe: "0",
			filter_plg: [
				{ text: 'Semua', id: '0' },
				{ text: 'Harga Full', id: '1' },
				{ text: 'Harga Prorate', id: '2' },
			],
			jlh_data_pppoe: '0',
			ttl_data_pppoe: '0',
			jlh_data_corpo: '0',
			ttl_data_corpo: '0',
			jlh_invoice: '0',
			ttl_invoice: '0',
			cari_dt_plg_corp: '',
			cari_dt_plg: '',
			checkbox: false,
			datas_corp: [],
			datas: [],
			form: new Form({
				invoice: {
					id: '',
					username: '',
					nama: '',
					nama_tempat: '',
					paket: '',
					harga_paket: '',
					diskon: '',
					ppn: '',
					tagihan: '',
					tanggal: '',
					tanggal_batas_bayar: '',
					total_bayar: '0',
					total: '0',
					status_bayar: '0',
					print_pajak: '0',
					print_diskon: '0',
					kickback: '0',
					ppn_keluaran: '0',
					pph23: '0',
					zakat: '0',
					downtime: '0',
					downtime_rp: '0',
					keterangan: '',
					kantor_id: '',
				},
				pejabat_approval: [],
			}),
			filename: '',
			menu2: false,
			menu: false,
			tipe_pelanggan_edit: '0',
			adaeror: [],
			loading: false,
			pagination: {
				page: 1,
				itemsPerPage: 25,
				total: 0,
			},
			loading_corp: false,
			pagination_corp: {
				page: 1,
				itemsPerPage: 25,
				total: 0
			},
		}
	},

	computed: {
		headers() {
			return [
				{ text: 'ID Pelanggan', value: 'pelanggan_internet.id', groupable: false, sortable: false, minWidth: '100px' },
				{ text: 'No Inv', value: 'id', groupable: false, },
				{ text: 'Tempat Instalasi', value: 'pelanggan_internet.nama', groupable: false, },
				{
					text: 'Tipe Invoice', value: 'tipe_invoice_val', groupable: false, sortable: false, align: " d-none", filter: value => {
						if (this.filter_pppoe.id == 1) {
							return value === "Penuh";
						} else if (this.filter_pppoe.id == 2) {
							return value === "Prorate";
						} else {
							return true;
						}
					},
				},
				{ text: 'Rp Kontrak', value: 'total_kontrak', groupable: false, align: "end", class: "text-right" },
				{ text: 'Rp BAYAR', value: 'total_bayar', groupable: false, align: "end", class: "text-right" },
				{ text: 'Aksi', value: 'actions', sortable: false, groupable: false, align: "center", class: "text-center" },
			]
		},

		headers_corp() {
			return [
				{ text: 'ID Pelanggan', value: 'pelanggan_internet.id', groupable: false, sortable: false, minWidth: '100px' },
				{ text: 'No Inv', value: 'id', groupable: false, },
				{ text: 'Tempat Instalasi', value: 'pelanggan_internet.nama', groupable: false, },
				{
					text: 'Tipe Invoice', value: 'tipe_invoice_val', groupable: false, sortable: false, align: " d-none", filter: value => {
						if (this.filter_corp.id == 1) {
							return value === "Penuh";
						} else if (this.filter_corp.id == 2) {
							return value === "Prorate";
						} else {
							return true;
						}
					},
				},
				{ text: 'Rp Kontrak', value: 'total_kontrak', groupable: false, align: "end", class: "text-right" },
				{ text: 'Rp BAYAR', value: 'total_bayar', groupable: false, align: "end", class: "text-right" },
				{ text: 'Aksi', value: 'actions', sortable: false, groupable: false, align: "center", class: "text-center" },
			]
		},
	},

	methods: {
		changeTab(tab) {
			this.filter.kantor = null;
			this.filter.search = null;
			this.filter.periode = new Date().toISOString().slice(0, 7);
			this.activeTab = tab;

		},
		onFilterChange() {
			if (this.activeTab == 1) {
				this.pagination.page = 1;
				this.loadUnpaid();
			}
			if (this.activeTab == 2) {
				this.pagination.page = 1;
				this.fetchDataCorp();
			}

		},
		reloadDataInvoice(item) {
			this.$Progress.start();
			Swal.fire({
				title: 'Yakin Reload Data Invoice?',
				text: "Invoice Akan Digenerate Ulang dan Riwayat Perubahan Harga Akan dihapus.",
				showCancelButton: true,
				confirmButtonColor: '#d33',
				cancelButtonColor: '#3085d6',
				confirmButtonText: 'Ya, Reload!'
			}).then((result) => {
				if (result.value) {
					let formData = new FormData();
					formData.append('datanya', JSON.stringify(item));
					axios.post('api/invoice/reloadDataInvoice', formData)
						.then((data) => {
							if (data.data.success) {
								Toast.fire({
									icon: 'success',
									title: data.data.message
								});
								if (this.activeTab == 1) {
									this.loadUnpaid();
								}
								if (this.activeTab == 2) {
									this.fetchDataCorp();
								}
								this.$Progress.finish();
							} else {
								Toast.fire({
									icon: 'error',
									title: data.data.message
								});

								this.$Progress.fail();
							}
						})
						.catch(e => {
							this.adaeror = e.response.data.errors;
							this.$Progress.fail();
							Toast.fire({
								icon: 'error',
								title: 'Gagal Generate Ulang'
							});
						})
				} else {
					this.$Progress.fail();
				}
			})
		},

		downloadFile(response, filename) {
			// It is necessary to create a new blob object with mime-type explicitly set
			// otherwise only Chrome works like it should
			var newBlob = new Blob([response.data], { type: 'application/pdf' });

			// IE doesn't allow using a blob object directly as link href
			// instead it is necessary to use msSaveOrOpenBlob
			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(newBlob);
				return
			}

			// For other browsers:
			// Create a link pointing to the ObjectURL containing the blob.
			const data = window.URL.createObjectURL(newBlob);
			var link = document.createElement('a');
			link.href = data;
			link.download = filename + '.pdf'
			document.body.appendChild(link);
			link.click();
			setTimeout(function () {
				// For Firefox it is necessary to delay revoking the ObjectURL
				window.URL.revokeObjectURL(data);
			}, 100)
		},


		printInvoice(item, ppn = false) {
			this.$Progress.start();
			let namaFileDownload = "Invoice " + item.pelanggan_internet.nama + " " + item.bulan_pemakaian;
			if (ppn) {
				axios.get('api/invoice/printpdf?id_invoice=' + item.id + '&ppn=1', { responseType: 'blob' }).then(response => {
					this.downloadFile(response, namaFileDownload);
					this.$Progress.finish();
				}, response => {
					Toast.fire({
						icon: 'error',
						title: data.data.data ? data.data.data : "Error!. Download Invoice Gagal."
					});
					this.$Progress.fail();
				});
			}

			if (!ppn) {
				axios.get('api/invoice/printpdf?id_invoice=' + item.id, { responseType: 'blob' }).then(response => {
					this.downloadFile(response, namaFileDownload);
					this.$Progress.finish();
				}, response => {
					Toast.fire({
						icon: 'error',
						title: data.data.data ? data.data.data : "Error!. Download Invoice Gagal."
					});
					this.$Progress.fail();
				});
			}

		},

		preventArrow(e) {
			if (e.which === 38 || e.which === 40) {
				e.preventDefault();
			}
			if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57) {
				e.preventDefault();
			}
		},

		updateHargaInvoice() {
			this.$Progress.start();
			if (this.form.pejabat_approval.length > 0) {
				const config = {
					headers: {
						'content-type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)
					}
				}
				let formData = new FormData();
				formData.append('datanya', JSON.stringify(this.form));
				axios.post('api/invoice/edit_harga_invoice', formData, config)
					.then((data) => {
						if (data.data.success) {
							Toast.fire({
								icon: 'success',
								title: data.data.message
							});
							this.$Progress.finish();
							if (this.activeTab == 1) {
								this.loadUnpaid();
							}
							if (this.activeTab == 2) {
								this.fetchDataCorp();
							}
							$('#modalUbahHarga').modal('hide');
						} else {
							Toast.fire({
								icon: 'error',
								title: 'Some error occured! Please try again'
							});

							this.$Progress.fail();
						}
					})
					.catch(e => {
						this.adaeror = e.response.data.errors;
						this.$Progress.fail();
						Toast.fire({
							icon: 'error',
							title: 'Some error occured! Please try again'
						});
					})
			} else {
				Toast.fire({
					icon: 'error',
					title: 'Pejabat Approval Harus Dipilih'
				});

				this.$Progress.fail();
			}

		},

		updateInvoice() {
			this.$Progress.start();

			if (this.form.invoice.status_bayar == 1 && !this.file) {
				Toast.fire({
					icon: "warning",
					title: "Pilih file terlebih dahulu sebelum upload!"
				});

				this.$Progress.fail();

				return;
			}

			Swal.fire({
				title: 'Are you sure?',
				text: "Apakah Anda Yakin Untuk Mengupdate Data Invoice pelanggan?",
				showCancelButton: true,
				confirmButtonColor: '#d33',
				cancelButtonColor: '#3085d6',
				confirmButtonText: 'Yes!'
			}).then((result) => {
				if (result.value) {

					let editFormData = new FormData();
					let dataUpdate = {};
					dataUpdate['id'] = this.form.invoice.id;
					dataUpdate['internet_id'] = this.form.invoice.internet_id
					dataUpdate['tanggal'] = this.form.invoice.tanggal;
					dataUpdate['tanggal_batas_bayar'] = this.form.invoice.tanggal_batas_bayar;
					dataUpdate['total_bayar'] = this.form.invoice.total_bayar;
					dataUpdate['status_bayar'] = this.form.invoice.status_bayar;
					dataUpdate['print_pajak'] = this.form.invoice.print_pajak;
					dataUpdate['print_diskon'] = this.form.invoice.print_diskon;
					dataUpdate['kickback'] = this.form.invoice.kickback;
					dataUpdate['total'] = this.form.invoice.total;
					dataUpdate['zakat'] = this.form.invoice.zakat;
					dataUpdate['pph23'] = this.form.invoice.pph23;
					dataUpdate['ppn_keluaran'] = this.form.invoice.ppn_keluaran;
					dataUpdate['downtime'] = this.form.invoice.downtime;
					dataUpdate['downtime_rp'] = this.form.invoice.downtime_rp;
					dataUpdate['keterangan'] = this.form.invoice.keterangan;
					dataUpdate['kantor_id'] = this.form.invoice.kantor_id;


					editFormData.append('file', this.file);
					editFormData.append('datanya', JSON.stringify(dataUpdate));

					const config = {
						headers: {
							'content-type': 'multipart/form-data'
						}
					};

					axios.post('api/invoice/edit_invoice', editFormData, config).then((data) => {
						if (data.data.success) {
							Toast.fire({
								icon: 'success',
								title: data.data.message
							});
							this.$Progress.finish();
							if (this.activeTab == 1) {
								this.loadUnpaid();
							}
							if (this.activeTab == 2) {
								this.fetchDataCorp();
							}
							this.filename = "";
							$('#modalEdit').modal('hide');
						} else {

							Toast.fire({
								icon: 'error',
								title: data.data.data ? data.data.data : "Error!. Try again later."
							});

							this.$Progress.fail();
						}
					})
						.catch(e => {
							Toast.fire({
								icon: 'error',
								title: data.data.data ? data.data.data : "Error!."
							});
							this.$Progress.fail();
						});
				}
			})
		},

		ubahHarga(item) {
			this.loadPejabatApproval();
			this.adaeror = [];
			this.form.reset();
			this.tipe_pelanggan_edit = item.pelanggan_internet.tipe_langganan;
			this.form.invoice.id = item.id;
			this.form.invoice.username = item.pelanggan_internet.username;
			this.form.invoice.nama = item.pelanggan_internet.pelanggan.nama;
			this.form.invoice.nama_tempat = item.pelanggan_internet.nama;
			this.form.invoice.paket = item.nama_paket;
			this.form.invoice.harga_paket = item.harga_paket;
			this.form.invoice.diskon = item.diskon;
			this.form.invoice.tanggal_batas_bayar = item.tanggal_batas_bayar;
			this.form.invoice.tanggal = item.tanggal;
			this.form.invoice.ppn = item.ppn;
			this.form.invoice.tagihan = this.getBulan(item.bulan_pemakaian);
			this.form.invoice.total_bayar = item.total_bayar;
			this.form.invoice.total = item.total;
			this.form.invoice.status_bayar = '0';
			this.form.invoice.print_pajak = item.print_pajak;
			this.form.invoice.print_diskon = item.print_diskon;
			this.form.invoice.kickback = item.kickback ? item.kickback : 0;
			this.form.invoice.pph23 = item.pph23 ? item.pph23 : 0;
			this.form.invoice.ppn_keluaran = item.ppn_keluaran ? item.ppn_keluaran : 0;
			this.form.invoice.zakat = item.zakat ? item.zakat : 0;
			this.form.invoice.downtime = item.downtime ? item.downtime : 0;
			this.form.invoice.downtime_rp = item.downtime_rp ? item.downtime_rp : 0;
			this.form.invoice.keterangan = item.keterangan;
			this.form.invoice.kantor_id = item.pelanggan_internet.kantor_id;
			$('#modalUbahHarga').modal('show');
		},

		bukaModal(item) {

			this.form.reset();
			this.form.invoice.internet_id = item.internet_id;
			this.tipe_pelanggan_edit = item.pelanggan_internet.tipe_langganan;
			this.form.invoice.id = item.id;
			this.form.invoice.username = item.pelanggan_internet.username;
			this.form.invoice.nama = item.pelanggan_internet.pelanggan.nama;
			this.form.invoice.nama_tempat = item.pelanggan_internet.nama;
			this.form.invoice.paket = item.nama_paket;
			this.form.invoice.harga_paket = item.harga_paket;
			this.form.invoice.diskon = item.diskon;
			this.form.invoice.tanggal_batas_bayar = item.tanggal_batas_bayar;
			this.form.invoice.tanggal = item.tanggal;
			this.form.invoice.ppn = item.ppn;
			this.form.invoice.tagihan = this.getBulan(item.bulan_pemakaian);
			this.form.invoice.total_bayar = item.total_bayar;
			this.form.invoice.total = item.total;
			this.form.invoice.status_bayar = '0';
			this.form.invoice.print_pajak = item.print_pajak;
			this.form.invoice.print_diskon = item.print_diskon;
			this.form.invoice.kickback = item.kickback ? item.kickback : 0;
			this.form.invoice.pph23 = item.pph23 ? item.pph23 : 0;
			this.form.invoice.ppn_keluaran = item.ppn_keluaran ? item.ppn_keluaran : 0;
			this.form.invoice.zakat = item.zakat ? item.zakat : 0;
			this.form.invoice.downtime = item.downtime ? item.downtime : 0;
			this.form.invoice.downtime_rp = item.downtime_rp ? item.downtime_rp : 0;
			this.form.invoice.keterangan = item.keterangan;
			this.form.invoice.kantor_id = item.pelanggan_internet.kantor_id;
			$('#modalEdit').modal('show');
		},

		tableGrouping(e) {
			if (e.length) {
				this.table_group_state = true;
			} else {
				this.table_group_state = false;
			}
		},

		/*generate_invoice(){
		   this.$Progress.start();
		   if(this.$gate.isAdmin()){
			   axios.get("api/invoice/generate")
			   .then((data)=>{
				   Toast.fire({
						   icon: 'success',
						   title: "Generate Invoice Berhasil"
				   });
				   this.loadUnpaid();
				   this.$Progress.finish();
			   })
			   .catch(e => {
				   Toast.fire({
							   icon: 'error',
							   title: 'Some error occured! Please try again'
				   });

				   this.$Progress.fail();
			   });
		   }
	   },*/

		async loadUnpaid() {
			this.loading = true;
			try {
				if (this.$gate.isAllowed("is_invoice")) {

					if (this.$gate.dataType('1')) {
						const bulan = this.filter.periode;
						const res = await axios.get('api/invoice/list_unpaid?tipe=1', {
							params: {
								page: this.pagination.page,
								per_page: this.pagination.itemsPerPage,
								search: this.filter.search,
								periode: bulan,
								kantor_id: this.filter.kantor?.id || null
							}
						});

						this.datas = res.data.data.data;
						this.pagination.total = res.data.data.total;

						const resTotal = await axios.get('api/invoice/list_unpaid_count?tipe=1', {
							params: {
								periode: bulan,
								kantor_id: this.filter.kantor?.id || null
							}
						});
						this.jlh_data_pppoe = parseInt(resTotal.data.data[0].jumlah ? resTotal.data.data[0].jumlah : 0);
						this.ttl_data_pppoe = parseInt(resTotal.data.data[0].total ? resTotal.data.data[0].total : 0);

					}

				}
			} catch (error) {
				console.error('Gagal memuat data:', error);
			} finally {
				this.loading = false;
			}

		},
		async fetchDataCorp() {
			this.loading_corp = true;
			try {
				if (this.$gate.dataType('2')) {
					const res = await axios.get('api/invoice/list_unpaid?tipe=2', {
						params: {
							page: this.pagination_corp.page,
							per_page: this.pagination_corp.itemsPerPage,
							search: this.filter.search,
							kantor_id: this.filter.kantor?.id || null
						}
					});

					this.datas_corp = res.data.data.data;
					this.pagination_corp.total = res.data.data.total;
					await axios.get("api/invoice/list_unpaid_count?tipe=2").then(({ data }) => {
						this.jlh_data_corpo = parseInt(data.data[0].jumlah ? data.data[0].jumlah : 0);
						this.ttl_data_corpo = parseInt(data.data[0].total ? data.data[0].total : 0);
					});
				}

			} catch (error) {
				console.error('Gagal mengambil data corp:', error);
			} finally {
				this.loading_corp = false;
			}
		},
		changeItemsPerPageCorp(perPage) {
			this.pagination_corp.itemsPerPage = perPage;
			this.pagination_corp.page = 1;
			this.fetchDataCorp();
		},
		loadPejabatApproval() {
			axios.get("api/keuangan/pejabat_list").then(({ data }) => (this.pejabat_list = data.data));
		},
		changeItemsPerPage(val) {
			this.pagination.itemsPerPage = val;
			this.pagination.page = 1;
			this.loadUnpaid();
		},
		getBulan(tanggal) {
			var tgltemp = new Date(tanggal);
			var tahun = tgltemp.getFullYear();
			var bulan = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

			return (bulan[tgltemp.getMonth()] + " " + tahun);
		},

		onUploadFile(e) {
			const file = e.target.files[0];
			if (!file) {
				this.filename = "";
				this.file = null;
				return;
			}

			const allowedExtensions = /\.(jpe?g|png|gif|pdf|xls|xlsx|csv)$/i;

			if (!allowedExtensions.test(file.name)) {
				this.filename = "ERROR! Hanya PDF, Image (JPEG/JPG/PNG), atau Excel (XLS/XLSX/CSV) yang diperbolehkan.";
				this.file = null;

				// Tambahkan notifikasi agar user tahu filenya ditolak
				Toast.fire({
					icon: "warning",
					title: "Format file tidak didukung!"
				});

				return;
			}

			// Jika file valid, simpan datanya
			this.filename = file.name;
			this.file = file;
		},
	},
	mounted() {
		this.fetchDataCorp();
		this.loadUnpaid();
	},
	created() {
		this.$Progress.start();

		//this.loadUnpaid();

		this.$Progress.finish();
	},
}
</script>
<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

.tanpawrap {
	white-space: nowrap;
}
</style>